export const FunctionPackagesPricesInfo = () => {
  return (
    <div className='flex pt-16 justify-between'>
      <div className='flex flex-col'>
        <h4 className='prose-heading4 pb-2'>Upgrade prices</h4>
        <p className='prose-paragraphBase text-gray-60 max-w-[52ch] mb-3'>
          Input prices and currency displayed for the customer when purchasing function package upgrades for the portal.
          You will still be invoiced your agreed upon price from Humphree. Prices for the legacy packages are only
          required for customers going from a system with an old package to the new ones.
          <br />
          <br />
          If a customer upgrades from one package to another, the difference will be displayed.
        </p>
      </div>
    </div>
  );
};
